<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-row>
        <el-col :span="6" v-for="(item, key) in tableData" :key="key">
          <el-card style="margin: 5px;height: 510px;width: 300px">
            <img :src="item.picPath" class="image" style="height: 400px" @click="openPre(item)">
            <div style="padding: 14px;">
              <span>{{ item.name }}</span>
              <div class="bottom clearfix">
                状态：
                <span v-if="item.used == true" style="color: green">
                           使用中
                        </span>
                <span v-else style="color: blueviolet">
                            未使用
                        </span>

                <el-button type="primary"  class="button" v-if="item.used == true && item.pluginsParams.length > 0" @click="setting(item)">配置参数</el-button>
                <el-button type="primary" class="button" v-if="item.used == false" @click="choosePage(item)">立即使用
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="展示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <img :src="priviewUrl" width="60%"/>
    </el-dialog>

    <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
      <el-form :model="plugin">
        <el-form-item :label="item.labelName" label-width="100px" v-if="item.displayType == 1" v-for="(item,key) in params" :key="key">
          <el-input v-model="item.cvalue" auto-complete="off" v-if="item.eleType == 1"></el-input>
          <div v-else-if="item.eleType == 2">
            <el-upload
              v-if="item.cvalue == null || item.cvalue == ''"
              :action="uploadUrl+'?key='+key"
              :on-success="handleSuccess"
              :limit="1">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div v-else>
              已上传({{item.cvalue.substr(item.cvalue.lastIndexOf("/")+1)}})  <el-button size="small" type="danger" @click="item.cvalue = ''">删除</el-button>
            </div>
          </div>
          <div v-else-if="item.eleType == 4">
            <el-switch
              v-model="item.cvalue"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              active-value="true"
              inactive-value="false">
            </el-switch>
          </div>
          <el-input-number v-else-if="item.eleType == 5" v-model="item.cvalue" auto-complete="off"></el-input-number>
          <el-input v-else-if="item.eleType == 6" type="textarea" :rows="5" v-model="item.cvalue" auto-complete="off"></el-input>
          <el-alert
            v-if="item.placeholder"
            :title="item.placeholder"
            type="success">
          </el-alert>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      uploadUrl:window.server.baseUrl+'/common/imageUpload',
      tableData: [],
      chooseId: "",
      priviewUrl: "",
      centerDialogVisible: false,
      store_id: 0,
      dialog:{
        dialogFormVisible:false,
        title:"配置参数",
        close:false,
      },
      plugin:{
        id:0,
        used:1,
        params:""
      },
      params:[],
    }
  },
  created() {
    this.store_id = this.$route.query.store_id;
    this.initData();
  },
  methods: {
    initData() {
      this.loading = true;
      var that = this;
      that.$api.get('/main_store/h5_config/' + this.store_id, null, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.tableData = res.data.consumerViews;
            that.chooseId = res.data.usedPageViewId;

          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },
    choosePage(row) {
      this.loading = true;
      var that = this;
      that.$api.put('/main_store/h5_config/' + this.store_id + "/" + row.uuid, null, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.initData();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },
    handleSuccess(response,file, fileList) {
      //file.id = response.ids[0];
      //file.ext = response.exts[0];
      console.log(file);
      this.params[response.key].cvalue = response.md5s[0];
    },
    setting(row) {
      this.tmpRow = row;
      this.dialog.title = "配置:"+row.name;
      this.plugin.id = row.id;
      this.params = row.pluginsParams;
      this.dialog.dialogFormVisible = true;
    },
    handleSave() {
      this.loading = true;
      var that = this;
      that.plugin.params = JSON.stringify(this.params);
      that.$api.put('/main_store/plugins/' + this.store_id + '/setting/'+that.plugin.id, that.plugin, response => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: '配置成功',
              type: 'success'
            });

            this.tmpRow.used=res.data.plugin.used;
            this.tmpRow.paramsStr=res.data.plugin.paramsStr;
            this.dialog.dialogFormVisible = false;
            this.initData();
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }

      });

      this.loading = false;
    },
    statusFormat(row, column) {
      return row.status == 2 ? "使用中" : "未使用";
    },
    openPre(row) {
      this.priviewUrl = row.picPath;
      this.centerDialogVisible = true;
    }
  },
}
</script>

<style lang="less">
@import '../../style/mixin';

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.table_container {
  padding: 20px;
  text-align: left;
}

.Pagination {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>

<style>
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 10px;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>



// WEBPACK FOOTER //
// src/pages/mainStore/StoreH5Config.vue